module.exports = __webpack_public_path__ + "media/images/landing-find-match-1-8245aadc00cbf7521aa1ac5ebe5dc7dd.jpg";